export class EnumApiCommodity {
    constructor() {
        /**
         * @dec 产品类型下拉数据
         * @method get
         * @params
         */
        this.commodity_product_type = {
            url: '/api/bpportal/pcsd-bp-activity/v1/activity/product/type/20043',
            method: 'get',
        };
        /**
         * @dec 产品组下拉数据
         * @method get
         * @params
         */
        this.commodity_group_info = {
            url: '/api/bpportal/pcsd-bp-activity/v1/activity/product/productGroupInfo',
            method: 'get',
        };
        /**
         * @dec 产品列表
         * @method post
         * @params
         */
        this.commodity_product_list = {
            url: '/api/bpportal-mall/bpportal-mall-product/channelProduct/list',
            method: 'post',
        };
        /**
         * @dec 活动产品详情
         * @method post
         * @params
         */
        this.commodity_active_product_list = {
            url: '/api/bpportal/pcsd-bp-activity/v1/activity/product/productDetailByIds',
            method: 'post',
        };
        /**
         * @dec 直播间下拉
         * @method get
         * @params
         */
        this.commodity_smb_live_broadcast = {
            url: '/api/bpportal/pcsd-bp-activity/v1/activity/productPool/listAll',
            method: 'get',
        };
    }
}
